import React from 'react';
import { Action } from 'util/constants';
import PostCommentsTabs from 'components/Posts/display/PostCommentsTabs';

interface Props {
  action: Action;
}

const ActionProfileTabs: React.FC<Props> = ({ action }) => {
  return <PostCommentsTabs kind="action" entityId={action.id} entityTitle={action.title} />;
};

export default ActionProfileTabs;
